import React from "react";
import { Link } from "react-router-dom";
import './notFound.css';

const NotFound = () => {
  return (
    <div className="sr-notfound">
      <div className="sr-notfound__top">
        <h1 className="sr-notfound__title">404</h1>
        <p className="sr-notfound__subtitle">Page Not Found</p>
      </div>
      <div className="sr-notfound__body">
        <p className="sr-notfound__text">The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/" className="sr-notfound__btn">Go Home</Link>
      </div>
    </div>
  );
};

export default NotFound;
